// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ProjectRole } from "./ProjectRole";
import {
  ProjectRoleFromJSON,
  ProjectRoleFromJSONTyped,
  ProjectRoleToJSON,
  ProjectRoleToJSONTyped,
} from "./ProjectRole";

/**
 *
 * @export
 * @interface ProjectUserUpdate
 */
export interface ProjectUserUpdate {
  /**
   *
   */
  role: ProjectRole;
}

/**
 * Check if a given object implements the ProjectUserUpdate interface.
 */
export function instanceOfProjectUserUpdate(value: object): value is ProjectUserUpdate {
  if (!("role" in value) || value["role"] === undefined) return false;
  return true;
}

export function ProjectUserUpdateFromJSON(json: any): ProjectUserUpdate {
  return ProjectUserUpdateFromJSONTyped(json, false);
}

export function ProjectUserUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProjectUserUpdate {
  if (json == null) {
    return json;
  }
  return {
    role: ProjectRoleFromJSON(json["role"]),
  };
}

export function ProjectUserUpdateToJSON(json: any): ProjectUserUpdate {
  return ProjectUserUpdateToJSONTyped(json, false);
}

export function ProjectUserUpdateToJSONTyped(
  value?: ProjectUserUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    role: ProjectRoleToJSON(value["role"]),
  };
}
